import { Grid } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

export default function CompFields({
  register,
  control,
  errors,
  getValues,
  setError,
  setValue,
  watch,
}) {
  const fields = [
    {
      label: "Name",
      name: "name",
      required: true,
      type: "text",
    },
    {
      label: "Subject",
      name: "subject",
      required: true,
      type: "text",
    },
    {
      label: "Prompt",
      name: "prompt",
      required: true,
      type: "text",
      lines: 12,
    },
    {
      label: "Content",
      name: "content",
      required: true,
      type: "text",
      lines: 12,
    },
  ];

  return (
    <Grid container spacing={2} rowSpacing={4} justifyContent="space-between">
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            {...field}
            fieldVariants="outlined"
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            defaultValue={watch(field.name)}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
